import { render, staticRenderFns } from "./GiubileoSchedaListPage.vue?vue&type=template&id=7f83fa96"
import script from "./GiubileoSchedaListPage.vue?vue&type=script&lang=js"
export * from "./GiubileoSchedaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports